import { render, staticRenderFns } from "./productCarbonFootprint.vue?vue&type=template&id=4b62fafd&scoped=true"
import script from "./productCarbonFootprint.vue?vue&type=script&lang=js"
export * from "./productCarbonFootprint.vue?vue&type=script&lang=js"
import style0 from "./productCarbonFootprint.vue?vue&type=style&index=0&id=4b62fafd&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b62fafd",
  null
  
)

export default component.exports